/**
 * Date: 2021-03-18 15:49:04
 * description:
 *
 * @format
 * @author zhizhan Copyright (c) 2019, YUNXI. All rights reserved. YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { Component, Fragment } from 'react';
// 路由对象
import { withRouter } from 'react-router-dom';

import { Layout, Menu, Icon } from 'antd';
// 代码热更新插件
import Cookie from 'js-cookie';
import { hot } from 'react-hot-loader';
import { routerList } from 'router/index';

import SiderBar from 'widget/SiderBar/SiderBarView';
import FooterBar from 'widget/FooterBar/FooterBarView';
import HeaderBar from 'widget/HeaderBar/HeaderBarView';

import styles from './LayoutLess.less';
const { Header, Footer, Content } = Layout;
import { inject } from 'mobx-react';
import config from '../../config/Config';
import moment from 'moment';
import Request from 'utils/request';
import PageTabs from 'widget/PageTabs/PageTabsView';
import Serv from './LayoutServ';
import { get, forEach } from 'lodash';
import { CacheSwitch, CacheRoute } from 'react-router-cache-route';
import RouterCache from 'utils/routerCache';
import { createBundle } from 'widget/Common';
import NotFound from 'bundle-loader?lazy&name=NotFoundView!widget/NotFound/NotFoundView';
import { Route, Switch, Redirect } from 'react-router-dom';
@inject('AppStore')
@withRouter
class LayoutView extends Component {
  constructor(props) {
    super(props);
    // 设置全局router对象，用于在Mod中的跳转
    window.app.router = this.props.history;

    this.state = {
      // false展开，true折叠
      collapsed: false,
      /** 是否隐藏侧边栏 */
      hideSider: false,
      orgId: '',
      showTabs: '',
      show: false,
      hasMenu: false, //等slider拿到菜单再展示页签,
      menuList: []
    };
  }

  componentWillMount() {
    const themes = localStorage.getItem('boc_themes') || config.themes;
    if (themes === 'yellow') {
      let a = document.getElementsByTagName('head')[0].getElementsByTagName('link');
      for (let i = 0; i < a.length; i++) {
        let elm = a[i];
        if (elm.href.indexOf('app.css') > -1) {
          elm.href = 'assets/css/yellow_app.css';
        }
      }
    }
    if (!Cookie.get('boc_auth')) {
      this.props.history.push('login');
    } else {
      this.setState({ show: true });
    }
    clearInterval(window.refreshToken);
    window.refreshToken = setInterval(async () => {
      const CurrentDate = moment().valueOf();
      const TokenValidTime = parseInt(localStorage.getItem('tokenValidTime'));
      if (TokenValidTime - CurrentDate < 10 * 60 * 1000) {
        const res = await Request({
          url: 'user/refresh/token',
          method: 'post',
          app: 'identity',
          version: 'v2',
          data: { token: Cookie.get('boc_auth') }
        });
        const CurrentDate = moment().valueOf();
        const tokenValidTime = CurrentDate + res.data.tokenValidTime * 1000;
        localStorage.setItem('tokenValidTime', tokenValidTime);
        Cookie.set(config.cookie.boc_auth, res.data.token);
        //储存cookie过期时间
      }
    }, 10 * 60 * 1000);
    if (localStorage.getItem('roleCode') == 'BOCMANAGER') {
      this.setState({ hideSider: false });
    } else {
      this.createRouter({hideSider: true})
      this.setState({ hideSider: true });
    }

    window.addEventListener('message', event => {
      if (event.data.eventKey == 'siderCollapsed') {
        this.setState({
          collapsed: event.data.eventValue
        });
        const { AppStore: appStore } = this.props;
        if (this.state.hideSider) {
          appStore.sendMessage({ eventKey: 'siderCollapsed', eventValue: event.data.eventValue });
        }
      }
    });
    Serv.getAppById().then(res => {
      this.setState({ showTabs: get(res, 'data.footTable', '1') });
    });
  }

  // 菜单折叠、展开切换
  toggle() {
    this.setState({
      collapsed: !this.state.collapsed
    });
    const { AppStore: appStore } = this.props;
    if (this.state.hideSider) {
      appStore.sendMessage({ eventKey: 'siderCollapsed', eventValue: this.state.collapsed });
    }
  }
  changeHasMenu({ flag, menuList }) {
    this.createRouter({menuList})
    this.setState({ hasMenu: flag, menuList });
  }

  createRouter({menuList, hideSider}){
    let arr = ['/productList', '/productDetail', '/', '/withoutPermission'];
    let router = routerList;
    if (hideSider) {
      router = routerList.filter(item => {
        return arr.includes(item.path);
      });
    } else {
      router = routerList.filter(item => {
        return menuList.includes(item.path);
      });
    }
    router = this.childrenToList(router);
    let routerData = RouterCache.routerFactory(router);
    this.getRouter = (
      <Fragment>
        <Switch>
          {routerData.routerList.map((route, idx) => {
            if (route.render) {
              return <Route key={'route_' + idx} path={route.path} exact component={route.render} />;
            } else {
              return <Route key={'route_' + idx} path={route.path} exact component={route.component()} />;
            }
          })}
          <Route component={createBundle(NotFound, '404')} />
        </Switch>
        <CacheSwitch>
          {routerData.cacheRouterList.map((route, idx) => {
            if (route.render) {
              return (
                <CacheRoute
                  cacheKey={RouterCache.urlName(route.path)}
                  path={route.path}
                  exact
                  component={route.render}
                  when='always'
                />
              );
            } else {
              return (
                <CacheRoute
                  cacheKey={RouterCache.urlName(route.path)}
                  path={route.path}
                  exact
                  component={route.component()}
                  when='always'
                />
              );
            }
          })}
        </CacheSwitch>
      </Fragment>
    );
  }
  changeOrg(orgId) {
    this.setState({
      orgId
    });
  }
  childrenToList(tree) {
    let list = [];
    forEach(tree, item => {
      list.push(item);
      if (item.children) {
        forEach(item.children, child => {
          list.push(child);
        });
      }
    });
    return list;
  }
  render() {
    const collapsed = this.state.collapsed;
    return (
      <div className={styles.layout}>
        <div className={styles.logo} />
        {this.state.show ? (
          <Layout>
            <HeaderBar collapsed={collapsed} changeOrg={e => this.changeOrg(e)} />
            {!this.state.hideSider ? (
              <Layout>
                <SiderBar
                  changeHasMenu={e => {
                    this.changeHasMenu(e);
                  }}
                  collapsed={collapsed}
                  orgId={this.state.orgId}
                  toggle={e => this.toggle()}
                />
                {this.state.hasMenu && (
                  <Content className={styles.layouMain}>
                    {this.state.showTabs !== '' && (
                      <PageTabs showTabs={this.state.showTabs + '' === '1' ? true : false} />
                    )}
                    <div className={styles.content}>{this.getRouter}</div>
                  </Content>
                )} 
              </Layout>
            ) : (
              <Layout>
                <Content className={styles.layouMain}>
                  <div className={styles.content + ' ' + styles.noPadding}>{this.getRouter}</div>
                </Content>
              </Layout>
            )}
          </Layout>
        ) : (
          ''
        )}
      </div>
    );
  }
}

// 使用热更新插件，代码改动时更新视图
export default hot(module)(LayoutView);



// WEBPACK FOOTER //
// ./src/widget/Layout/LayoutView.js